<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form
        size="small"
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="">
          <el-select v-model="formInline.status" placeholder="商家状态">
            <el-option label="全部" value="-1"></el-option>
            <el-option
              v-for="(item, index) in status"
              :key="index"
              :label="item"
              :value="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="formInline.audit_status" placeholder="审核状态" clearable>
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="审核通过" :value="1"></el-option>
            <el-option label="审核拒绝" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=""
          ><el-input v-model="formInline.name" placeholder="商家名称"></el-input
        ></el-form-item>
        <el-form-item
          ><el-button icon="el-icon-search" @click="onSubmit"
            >查询</el-button
          ></el-form-item
        >
      </el-form>
    </div>

    <!--添加商家-->
    <div class="common-level-rail">
      <el-button
        size="small"
        icon="el-icon-plus"
        type="primary"
        @click="addClick"
        v-auth="'/plus/supply/supply/add'"
        >添加商家</el-button
      >
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table
            size="small"
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column prop="supply_id" label="商家ID" width="80"></el-table-column>
            <el-table-column prop="name" label="商家名称" min-width="120"></el-table-column>
            <el-table-column
              prop="user_id"
              label="关联用户ID"
              width="120"
            ></el-table-column>
            <el-table-column label="账号" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.shop_user">{{
                  scope.row.shop_user.user_name
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="商家等级" width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.kmd_grade.name }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              width="120"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="audit_status" label="审核状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="getAuditStatusType(scope.row.audit_status)" size="small">
                  {{ getAuditStatusText(scope.row.audit_status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="reason" label="拒绝原因" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="是否启用" width="100">
              <template slot-scope="scope">
                <el-switch
                  @change="setSupplyStatus(scope.row)"
                  v-model="scope.row.status"
                  active-color="#13ce66"
                  inactive-color="#c0c4cc"
                  :active-value="1" 
                  :inactive-value="0"
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="is_default" label="是否默认" width="100">
              <template slot-scope="scope">
                <el-switch
                  @change="setSupplyDefault(scope.row)"
                  v-model="scope.row.is_default"
                  active-color="#13ce66"
                  inactive-color="#c0c4cc"
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
              width="160"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="140">
              <template slot-scope="scope">
                <el-button
                  @click="editClick(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  @click="reviewClick(scope.row)"
                  type="text"
                  size="small"
                  :disabled="scope.row.audit_status !== 0"
                  >审核</el-button
                >
                <el-button
                  @click="deleteClick(scope.row)"
                  v-auth="'/plus/supply/supply/delete'"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <!-- 审核弹窗 -->
    <el-dialog 
      title="审核商家" 
      :visible.sync="dialogVisible" 
      width="500px" 
      @close="dialogFormVisible" 
      :close-on-click-modal="false" 
      :close-on-press-escape="false" 
      :append-to-body="true"
    >
      <el-form :model="auditForm" label-width="100px" ref="auditForm">
        <el-form-item label="商家名称">
          <span>{{ auditForm.name }}</span>
        </el-form-item>
        <el-form-item label="关联用户">
          <span>{{ auditForm.user_name || '-' }}</span>
        </el-form-item>
        <el-form-item label="商家等级">
          <span>{{ auditForm.grade_name || '-' }}</span>
        </el-form-item>
        <el-form-item label="审核状态" prop="audit_status" required>
          <el-radio-group v-model="auditForm.audit_status">
            <el-radio :label="1">审核通过</el-radio>
            <el-radio :label="2">审核拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="拒绝原因" prop="reason" v-if="auditForm.audit_status === 2">
          <el-input 
            type="textarea" 
            v-model="auditForm.reason" 
            placeholder="请填写拒绝原因" 
            :rows="4" 
            maxlength="200" 
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAudit" :loading="auditLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SupplyApi from "@/api/supply.js";
export default {
  components: {},
  inject: ["reload"],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      formInline: {
        status: '-1',
        audit_status: '',
        name: ''
      },
      status: ["禁用", "启用"],
      /*审核弹窗*/
      dialogVisible: false,
      auditForm: {
        supply_id: "",
        name: "",
        user_name: "",
        grade_name: "",
        audit_status: 1,
        reason: ""
      },
      auditLoading: false
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /* 获取审核状态文本 */
    getAuditStatusText(status) {
      const statusMap = {
        0: '待审核',
        1: '审核通过',
        2: '审核拒绝'
      };
      return statusMap[status] || '-';
    },
    
    /* 获取审核状态标签类型 */
    getAuditStatusType(status) {
      const typeMap = {
        0: 'warning',
        1: 'success',
        2: 'danger'
      };
      return typeMap[status] || 'info';
    },

    /*关闭审核弹窗重置数据*/
    dialogFormVisible() {
      this.dialogVisible = false;
      this.auditForm = {
        supply_id: "",
        name: "",
        user_name: "",
        grade_name: "",
        audit_status: 1,
        reason: ""
      };
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {
        status: this.formInline.status,
        audit_status: this.formInline.audit_status,
        name: this.formInline.name,
        page: self.curPage,
        list_rows: self.pageSize
      };
      self.loading = true;
      SupplyApi.supplyList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          console.log(self.tableData);
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加活动*/
    addClick() {
      this.$router.push("/plus/supply/supply/add");
    },
    jumpClick(e){
      this.$router.push({
          path: '/store/index',
          query: {
            supply_id: e.supply_id
          }
        });
    },

    /*编辑活动*/
    editClick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: "/plus/supply/supply/edit",
        query: {
          supply_id: supply_id
        }
      });
    },

    /*审核按钮点击*/
    reviewClick(row) {
      this.auditForm = {
        supply_id: row.supply_id,
        name: row.name,
        user_name: row.shop_user ? row.shop_user.user_name : '',
        grade_name: row.kmd_grade ? row.kmd_grade.name : '',
        audit_status: 1,
        reason: ""
      };
      this.dialogVisible = true;
    },
    
    /*提交审核*/
    submitAudit() {
      // 验证拒绝原因
      if (this.auditForm.audit_status === 2 && !this.auditForm.reason) {
        this.$message.error('请填写拒绝原因');
        return;
      }
      
      this.auditLoading = true;
      SupplyApi.auditSupply({
        supply_id: this.auditForm.supply_id,
        audit_status: this.auditForm.audit_status,
        reason: this.auditForm.reason || ''
      }, true)
        .then(data => {
          this.auditLoading = false;
          if (data.code === 1) {
            this.$message.success(data.msg || '审核成功');
            this.dialogVisible = false;
            this.getTableList();
          } else {
            this.$message.error(data.msg || '审核失败');
          }
        })
        .catch(error => {
          this.auditLoading = false;
          this.$message.error('审核请求失败');
        });
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          SupplyApi.delSupply(
            {
              supply_id: row.supply_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: "商家删除成功",
                  type: "success"
                });
                this.onSubmit();
              } else {
                self.$message.error("删除失败：" + (data.msg || "未知错误"));
              }
            })
            .catch(error => {
              self.$message.error("删除请求失败");
            });
        })
        .catch(() => {});
    },
    /*
     *设置默认供应商
     */
    setSupplyDefault(item) {
      let self = this;
      let form = {
        supply_id: item.supply_id,
        is_default: item.is_default,
        operation: "setdefault"
      };
      SupplyApi.saveSupply(form, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: "恭喜你，设置成功",
              type: "success"
            });
            self.getTableList();
          } else {
            self.$message.error(data.msg || "设置失败");
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
          self.$message.error("设置请求失败");
        });
    },
     /*
     *设置供应商启用状态
     */
    setSupplyStatus(item) {
      let self = this;
      let form = {
        supply_id: item.supply_id,
        status: item.status,
        operation: "setStatus"
      };
      SupplyApi.saveSupply(form, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: "恭喜你，设置成功",
              type: "success"
            });
            self.getTableList();
          } else {
            self.$message.error(data.msg || "设置失败");
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
          self.$message.error("设置请求失败");
        });
    }
  }
};
</script>

<style scoped>
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/supply/supply/index.vue